import Preview from './Preview'

export default {
  name: 'ForceEditView',
  extends: Preview,
  computed: {
    editSubmit: () => true
  },
  created() {
    const bus = this.$bus
    if (!bus.params.token || !bus.params.tenantId) {
      this.$router.replace({
        name: 'preview'
      })
    }
  },
  methods: {}
}
